import { Component, Input } from "@angular/core";


@Component({
		selector: 'app-veicolo-card',
		templateUrl: './veicolo-card.component.html',		
})
export class VeicoloCardComponent {
	@Input()
	veicolo: any;

	@Input()
	loggato: boolean;
}